import { useNavigate, useParams } from 'react-router';
import { RestS } from '../../../rest/rest-service';
import DisbursementHeader from '../DisbursementHeader/DisbursementHeader';
import styles from './DisbursementSuccess.module.scss';
import { DisbursementColdState, LendingStatus, disbursementRoutes } from '../../../interfaces/interfaces';
import { useEffect, useState } from 'react';
import CircularLoader from '../../../components/common/CircularLoader/CircularLoader';
import { RiCheckboxCircleFill as SuccessIcon } from 'react-icons/ri';
import { formatNumberWithComma } from '../../../components/functions/utilities';

const DisbursementSuccess = () => {
    const { formId } = useParams();
    const navigate = useNavigate();
    const [disbursementData, setDisbursementData] = useState({ invoiceDetails: { invoiceAmount: 0 } });
    const [loading, setLoading] = useState(true);

    const checkAndSetJourneyStatus = async () => {
        try {


            const { state, success, disbursementData, formSteps } = await RestS.getDisbursementFormData(Number(formId));

            if (state == DisbursementColdState.accessDenied) {
                navigate('/404', {
                    replace: true
                })
            } else if (state == DisbursementColdState.linkExpired) {
                // navigate to link expired page
                navigate(`${disbursementRoutes?.disbursementSections}/${disbursementRoutes?.disbursementExpired}/${formId}`, { replace: true })
                return;
            } else {
                console.log('disbursementFormData', disbursementData);
                const successStatuses = new Set([LendingStatus.APPROVED, LendingStatus.PENDING_APPROVAL, LendingStatus.REJECTED])
                if (successStatuses?.has(disbursementData['applicationStatus'])) {
                    setDisbursementData(disbursementData?.data);
                } else {
                    setDisbursementData(disbursementData?.data);
                    navigate(`${disbursementRoutes?.disbursementSections}/${formId}`, { replace: true })
                }
            }
        } catch (error) {
            console.log('error', error);
            throw error;
        }
    }

    useEffect(() => {
        // setLoading(false)
        (async () => {
            try {
                await checkAndSetJourneyStatus();
            } catch (error) {
                console.log('error', error)
            } finally {
                setLoading(false);
            }
        })()
    }, [])


    return (
        <div className={styles.rootContainer}>
            {loading ?
                <div className={styles.loadingContainer}>
                    <CircularLoader />
                </div>
                :
                <div className={styles.rootContainer}>
                    <DisbursementHeader />
                    <div className={styles.bodyContainer}>
                        <div className={styles.successContainer}>
                            <div className={styles.successIcon}>
                                <SuccessIcon />
                            </div>
                            <div className={styles.successTitle}>
                                Application Submitted!
                            </div>
                            <div className={styles.successSubText}>
                                You have applied for a disbursement <br /> of <span className={`${styles.bold} ${styles.green}`}>₹{`${formatNumberWithComma(disbursementData?.invoiceDetails?.invoiceAmount) ?? 0}`}</span>   <br /> to <span className={styles.bold}>Supplier ABC</span>.
                            </div>
                            <div className={styles.successSubText}>
                                Amount will be disbursed within 90 minutes.
                            </div>
                        </div>
                    </div>
                </div>}
        </div>
    );
}

export default DisbursementSuccess;